<script lang="ts">
	import type { BrandConfig } from '$lib/brand/types';

	let { config }: { config: BrandConfig } = $props();

	// Default values
	const defaultWebsiteUrl = 'artificerinnovations.com';
	const defaultBrandNameRelationship = 'Artificer Innovations, LLC';

	// Use brand value for websiteUrl, or legalIntroSettings override, or fall back to default
	const websiteUrl = config.legalIntroSettings?.websiteUrl ?? config.brand ?? defaultWebsiteUrl;
	const brandNameRelationship = config.legalIntroSettings?.brandNameRelationship ?? defaultBrandNameRelationship;
</script>

<div class="legal-intro">
	<p>
		This Privacy Policy describes how <strong>{brandNameRelationship}</strong> ("Company", "we", "our", or "us") collects, uses, and protects the information you provide when using <strong>{websiteUrl}</strong> and all other websites operated by Artificer Innovations, LLC (collectively, the "Sites") and when engaging our consulting services or purchasing our digital products.
	</p>
</div>

<style>
	.legal-intro {
		margin-bottom: 0;
	}

	.legal-intro p {
		font-size: 1rem;
		line-height: 1.6;
		color: var(--text-color);
		margin: 0 0 1rem 0;
	}

	.legal-intro strong {
		color: var(--accent-color);
		font-weight: 600;
	}
</style>
